export class SelectOptionValue {
    public id: number = 0;
    public displayName: string;
}
export class TextSelectOptionValue {
    public constructor(public value: string, public displayName: string) { }
}
